const {h, render, Component} = require('preact');
const OrderContainer = require('../main/order')
const ClaimContainer = require('../gplus/claim/claim')
const OrdersView = require('../../views/main/orders_list')
const ClaimsView = require('../../views/gplus/claims_list')

class ItemList extends Component {
  constructor(props) {
    super(props);
    this.createTable = this.createTable.bind(this);
    this.state = {}
  }

  getDataByType(type) {
    let pageType = this.props.pageType
    switch (type) {
      case 'tableClass':
        return pageType === 'orders' ? 'orderTableRow' : 'claimTableRow'

      case 'itemContainer':
        return pageType === 'orders' ? OrderContainer : ClaimContainer

      case 'itemsView':
        return pageType === 'orders' ? OrdersView : ClaimsView
    }
  }

  createTable() {
    let table = [], itemTableRow, ItemContainer
    itemTableRow = this.getDataByType('tableClass')
    ItemContainer = this.getDataByType('itemContainer')
    if (this.props.items && this.props.items.length > 0) {
      let columns = 2, page = this.props.items.length || 0, rows = Math.ceil(page / columns);
      for (let row = 0; row < rows; row++) {
        let children = []
        for (let col = 0; col < columns; col++) {
          let currentIndex = columns * row + col
          if (currentIndex < this.props.items.length) {
            children.push(<ItemContainer item={this.props.items[currentIndex]}/>)
          }
        }
        if(children.length==1)
          children.push(<ItemContainer/>)
        table.push(<tr class={itemTableRow}>{children}</tr>)
      }
      return table;
    }
  }


  render() {
    let ItemsView = this.getDataByType('itemsView')
    return (
      <ItemsView page='listing' itemsTable={this.createTable.bind(this)} isLoadingInProgress={this.props.isLoadingInProgress}
      />
    )
  }
}

module.exports = ItemList
